import styled from "@emotion/styled"
import { FlexContainer } from "../../../styled/flexbox.styled"

export const WarrenContainer = styled(FlexContainer)({
  height: "calc(100vh - 50px)",
  flexDirection: "column",
  width: "100%",
  overflow: "hidden",
  padding: "0 80px",
})

export const ResponseContainer = styled(FlexContainer)({
  flexDirection: "column",
  flexGrow: 1,
  overflowY: "auto",
  padding: "20px",
  gap: "30px",
})

export const SectionContainer = styled.div({
  width: "100%",
})

export const TableContainer = styled.div({
  width: "100%",
  height: "500px",
})

export const TextContent = styled.div({
  maxWidth: "800px",
  textAlign: "left",
  padding: "12px 16px",
})

export const InputContainer = styled(FlexContainer)({
  padding: "20px",
  alignItems: "center",
  justifyContent: "center",
  width: "100%",
})

export const UserMessageContainer = styled.div({
  width: "100%",
  display: "flex",
  justifyContent: "flex-end",
  marginBottom: "10px",
})

export const UserMessageBubble = styled.div({
  backgroundColor: "#394B59",
  color: "#F5F8FA",
  padding: "12px 16px",
  borderRadius: "12px",
  maxWidth: "70%",
  wordWrap: "break-word",
})

export const AssistantSectionsContainer = styled(FlexContainer)({
  flexDirection: "column",
  width: "100%",
  gap: "20px",
})

export const ProgressMessage = styled.div({
  color: "#8A9BA8",
  fontSize: "14px",
  fontStyle: "italic",
  padding: "8px 16px",
  marginTop: "4px",
})

export const ErrorMessage = styled.div({
  color: "#FF6B6B",
  fontSize: "14px",
  padding: "8px 16px",
  marginTop: "4px",
  backgroundColor: "rgba(255, 107, 107, 0.1)",
  borderRadius: "8px",
})
